import Vue from 'vue'
import VueRouter from 'vue-router'


/* 权限管理 */
const RoleDetailView = () => import(/* webpackChunkName: 'view_role' */ "./views/auth/role/RoleDetailView")
const RoleListView = () => import(/* webpackChunkName: 'view_role' */ "./views/auth/role/RoleListView")
const AuthCategoryDetail = () => import(/* webpackChunkName: 'view_role' */ "./views/auth/category/AuthCategoryDetail")
const AuthCategoryList = () => import(/* webpackChunkName: 'view_role' */ "./views/auth/category/AuthCategoryList")
const ApiDetailView = () => import(/* webpackChunkName: 'view_role' */ "./views/auth/api/ApiDetailView")
const ApiListView = () => import(/* webpackChunkName: 'view_role' */ "./views/auth/api/ApiListView")
const AdminListView = () => import(/* webpackChunkName: 'view_role' */ "./views/auth/admin/AdminListView")
const AdminDetailView = () => import(/* webpackChunkName: 'view_role' */ "./views/auth/admin/AdminDetailView")
/* --- 基础页面 --- */
const SignIn = () => import(/* webpackChunkName: 'components_home' */ './components/SignIn')
const ForgotPasswordView = () => import(/* webpackChunkName: 'components_home' */ "./views/user/ForgotPasswordView")
const Home = () => import(/* webpackChunkName: 'components_home' */ "./components/Home")
/* --- 主页 --- */
const Index = () => import(/* webpackChunkName: 'view_index' */ "./views/index/Index")
/* 用户管理 */
/* 用户管理 */
const UpdateThePasswordView = () => import(/* webpackChunkName: 'view_user' */ "./views/user/UpdateThePasswordView")
const UpdateUserInfoView = () => import(/* webpackChunkName: 'view_user' */  "./views/user/UpdateUserInfoView")
const RegisteredAccountView = () => import(/* webpackChunkName: 'view_user' */  "./views/user/RegisteredAccountView")
/* 关于系统 */
const AboutSystemView = () => import(/* webpackChunkName: 'view_user' */ "./views/user/AboutSystemView")
// 门店
const StoreMessage = () => import(/* webpackChunkName: 'view_user' */ "./views/store/StoreMessage")
// 添加门店信息
const AddStoreInfo = () => import(/* webpackChunkName: 'view_user' */ "./views/store/AddStoreInfo")
//编辑门店信息
const EditStoreInfoDetail = () => import(/* webpackChunkName: 'view_user' */ "./views/store/EditStoreInfoDetail")
// 添加评分标准
const AddScoreStandard = () => import(/* webpackChunkName: 'view_user' */ "./views/store/AddScoreStandard")
//编辑评分标准
const EditScoreStardDetail = () => import(/* webpackChunkName: 'view_user' */ "./views/store/EditScoreStardDetail")
//查看刮刮码
const ScratchCode = () => import(/* webpackChunkName: 'view_user' */ "./views/code/ScratchCode")
// 添加刮刮码
const AddScratchCode = () => import(/* webpackChunkName: 'view_user' */ "./views/code/AddScratchCode")
// 核销刮刮码
const CheckScratchCode = () => import(/* webpackChunkName: 'view_user' */ "./views/code/CheckScratchCode")
// 编辑刮刮码
const EditScratchCodeDetail = () => import(/* webpackChunkName: 'view_user' */ "./views/code/EditScratchCodeDetail")
// 核销码列表
const ScratchCheckLog = () => import(/* webpackChunkName: 'view_user' */ "./views/code/ScratchCheckLog")
// 核销记录详情
const EditScratchCheckLogDetail = () => import(/* webpackChunkName: 'view_user' */ "./views/code/EditScratchCheckLogDetail")
Vue.use(VueRouter)
const routes = [
    {
        path: '/sign-in',
        component: SignIn,
    }, {
        path: '/forgot-password',
        component: ForgotPasswordView,
    }, {
        path: '/user-register',
        component: RegisteredAccountView,
    },
    {
        path: '/',
        component: Home,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'admin',
                component: AdminListView,
                meta: { requiresAuth: true, requiresAdmin: false }
            },
            {
                path: 'admin-detail',
                component: AdminDetailView,
                meta: { requiresAuth: true, requiresAdmin: false }
            },
            {
                path: 'admin-auth-api',
                component: ApiListView,
                meta: { requiresAuth: true, requiresAdmin: false }
            },
            {
                path: 'admin-auth-api-detail',
                component: ApiDetailView,
                meta: { requiresAuth: true, requiresAdmin: false }
            },
            {
                path: 'admin-auth-category',
                component: AuthCategoryList,
                meta: { requiresAuth: true, requiresAdmin: false }
            },
            {
                path: 'admin-auth-category-detail',
                component: AuthCategoryDetail,
                meta: { requiresAuth: true, requiresAdmin: false }
            },
            {
                path: 'admin-auth-role',
                component: RoleListView,
                meta: { requiresAuth: true, requiresAdmin: false }
            },
            {
                path: 'admin-auth-role-detail',
                component: RoleDetailView,
                meta: { requiresAuth: true, requiresAdmin: false }
            },
            // {
            //     path: 'user-update-info',
            //     component: UpdateUserInfoView,
            //     meta: { requiresAuth: true, requiresAdmin: false }
            // },
            // {
            //     path: 'user-update-password',
            //     component: UpdateThePasswordView,
            //     meta: { requiresAuth: true, requiresAdmin: false }
            // },
            // {
            //     path: 'about-system',
            //     component: AboutSystemView,
            //     meta: { requiresAuth: true, requiresAdmin: false }
            // },
        ]
    },
    {
        path: '/',
        component: Home,
        // redirect: 'store-message',
        children: [
            {

                path: 'scratch-code',
                component: ScratchCode,
                meta: { requiresAuth: true, requiresAdmin: false }
            },
            {
                path: 'add-scratch-code',
                component: AddScratchCode,
                meta: { requiresAuth: true, requiresAdmin: false }
            },
            {

                path: 'check-scratch-code',
                component: CheckScratchCode,
                meta: { requiresAuth: true, requiresAdmin: false }
            },
            {

                path: 'edit-scratch-code-detail',
                component: EditScratchCodeDetail,
                meta: { requiresAuth: true, requiresAdmin: false }
            },
            {

                path: 'scratch-check-log',
                component: ScratchCheckLog,
                meta: { requiresAuth: true, requiresAdmin: false }
            },
            {

                path: 'edit-scratch-check-log-detail',
                component: EditScratchCheckLogDetail,
                meta: { requiresAuth: true, requiresAdmin: false }
            },
            {
                path: 'index',
                component: Index,
                meta: { requiresAuth: true, requiresAdmin: false }
            },
            {
                path: 'user-update-info',
                component: UpdateUserInfoView,
                meta: { requiresAuth: true, requiresAdmin: false }
            },
            {
                path: 'user-update-password',
                component: UpdateThePasswordView,
                meta: { requiresAuth: true, requiresAdmin: false }
            },
            {
                path: 'about-system',
                component: AboutSystemView,
                meta: { requiresAuth: true, requiresAdmin: false }
            },
            {

                path: 'store-message',
                component: StoreMessage,
                meta: { requiresAuth: true, requiresAdmin: false }
            },
            {

                path: 'add-store-info',
                component: AddStoreInfo,
                meta: { requiresAuth: true, requiresAdmin: false }
            },
            {

                path: 'edit-store-info-detail',
                component: EditStoreInfoDetail,
                meta: { requiresAuth: true, requiresAdmin: false }
            },
            {

                path: 'add-score-standard',
                component: AddScoreStandard,
                meta: { requiresAuth: true, requiresAdmin: false }
            },
            {

                path: 'edit-score-stard-detail',
                component: EditScoreStardDetail,
                meta: { requiresAuth: true, requiresAdmin: false }
            },

        ]
    }
]
const router = new VueRouter({
    mode: 'history',
    routes: routes  // (缩写) 相当于 routes: routes
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        //如果未登录，跳转到登录页
        if (!Vue.prototype.$common.loggedIn()) {
            next({
                path: '/sign-in'
            })
        } else {
            //获取用户信息
            let user = Vue.prototype.$common.getAuthority();
            if (user) {
                if (to.meta.requiresAdmin) {
                    next({ path: '/index' })
                } else {
                    next()
                }
            } else {
                next({
                    path: '/sign-in'
                })
            }
        }
    } else {
        next() // 确保一定要调用 next()
    }
});


export default router
